<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-right-padding no-left-padding">
              <table *ngIf="!sppDevice && dataScope?.toLowerCase() !== 'swissdamed'" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Device Status</th>
                    <th class="col-sm-6">Member State Where Device is Placed on the EU Market</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Device Status')">
                      <label controlName="deviceStatus"> </label> </td>
                      <td [ngClass]="isDefault('Member State Where Device is Placed on the EU Market')">
                        <label controlName="memberStateForDevicePlacementInEu"></label>
                      </td>
                  </tr>
                </tbody>
              </table>
              <table *ngIf="!sppDevice && dataScope?.toLowerCase() === 'swissdamed'" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-12">Device Status</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Device Status')">
                      <label controlName="deviceStatus"> </label> </td>
                  </tr>
                </tbody>
              </table>
              <table *ngIf="sppDevice" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-12">Device Status</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Device Status')">
                      <label controlName="deviceStatus"> </label> </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr *ngIf="!sppDevice && dataScope?.toLowerCase() !== 'swissdamed'">
            <td class="col-sm-12 no-right-padding no-left-padding">

              <table formArrayName="membersAvailForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Member State(s) Where Device is Made Available</th>
                    <th class="col-sm-4">Availability Start Date</th>
                    <th class="col-sm-4">Availability End Date</th>
                  </tr>
                  <ng-container *ngIf="membersAvailForm?.controls?.length; else emptyTemplate3fields">
                  <tr formGroupName="{{i}}" *ngFor="let item of membersAvailForm.controls; let i = index">
                    <td [ngClass]="isDefault('Member State(s) Where Device is Made Available')">
                      <label controlName="memberStateValue"></label> </td>
                    <td [ngClass]="isDefault('Member State(s) Where Device is Made Available')">
                      <label controlName="startDate"></label></td>
                    <td [ngClass]="isDefault('Member State(s) Where Device is Made Available')">
                      <label controlName="endDate"></label></td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr *ngIf="applicableRegulation != 'MDR' && !isSwissdamedLegacyDeviceRegulation() && !isSwissdamedIvddDeviceRegulation()">
            <td class="no-right-padding no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>New Device?</th>
                  </tr>
                  <tr>
                    <td><label controlName="newDevice"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate3fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
